/**
 * TextHeading, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/TextHeadingComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

export const TextHeadingCore = {
  type: 'TextHeading',
  name: 'Text Heading',
  icon: '📝',
  description: 'Large title text at the top of a screen.',
  category: 'display',
  maxPerScreen: null,
  getDefaultProperties() {
    return {
      text: 'Heading Text',
      visible: true,
    };
  },
  getPropertySchema() {
    return {
      text: {
        type: 'string',
        label: 'Text',
        required: true,
        maxLength: 80,
      },
      visible: {
        type: 'boolean',
        label: 'Visible',
        required: false,
      },
    };
  },
  validateProperties(properties) {
    const errors = [];
    const warnings = [];

    if (!properties.text || properties.text.trim().length === 0) {
      errors.push('Heading text is required');
    }

    if (properties.text && properties.text.length > 80) {
      errors.push('Heading text must be 80 characters or less');
    }

    if (properties.text && properties.text.length > 60) {
      warnings.push('Long headings may not display well on all devices');
    }

    return { errors, warnings };
  },
  transformToWhatsApp(properties) {
    return {
      type: 'TextHeading',
      text: properties.text,
    };
  },
  transformFromWhatsApp(whatsappComponent) {
    return {
      text: whatsappComponent.text,
      visible: true,
    };
  },
};
